import { useSearchParams } from 'react-router-dom';
import useUserMetrics from '../hooks/useUserMetrics';
import DineOut from './recommendations/DineOut';
import DineIn from './recommendations/DineIn';
import CookAtHome from './recommendations/CookAtHome';
import SurpriseMe from './recommendations/SurpriseMe';

const Recommendations = () => {
  const [searchParams] = useSearchParams();
  const comfort = searchParams.get('comfort') || 'dine-out';
  const { metrics, refresh } = useUserMetrics();
  const preferences = {
    comfort,
    vibe: searchParams.get('vibe'),
    cuisine: searchParams.get('cuisine'),
    dietary: searchParams.get('dietary'),
    location: searchParams.get('location'),
  };

  switch(comfort) {
    case 'dine-out':
      return <DineOut preferences={preferences} metrics={metrics} onMetricRefresh={refresh} />;
    case 'dine-in':
      return <DineIn preferences={preferences} metrics={metrics} onMetricRefresh={refresh} />;
    case 'cook-at-home':
      return <CookAtHome preferences={preferences} metrics={metrics} onMetricRefresh={refresh} />;
    case 'surprise-me':
      return <SurpriseMe metrics={metrics} onMetricRefresh={refresh} />;
    default:
      return <DineOut preferences={preferences} metrics={metrics} onMetricRefresh={refresh} />;
  }
};

export default Recommendations;
